import React from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySearchResult from "../BsySearchResult";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import BsySlidePane from "../BsySlidePane";
import BsyDashboardComponent from "../dashboard/BsyDashboardComponent";
import { createTooltip } from "../../utils/createTooltip";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom";

// eslint-disable-next-line no-empty-pattern
class BsySystemRightMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      haveNews: false,
      noticeinfo: [],
      name: BsyUtils.formatUserThumb(window.localDevInfo.user.nickname),
      search: props.search || false,
      showSearch: props.showSearch || false,
      hasSplit: props.hasSplit || false,
    };
    this.searchResultRef = React.createRef();
  }

  componentDidMount = () => {
    this._getMsgUnread();
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  createUpDateTip = (c) => {
    let noticeinfo = c ? c.noticeinfo : this.state.noticeinfo;
    if (
      BsyUtils.isObjectEmpty(noticeinfo) ||
      window.$(".bsy-update-tip").length > 0
    ) {
      return;
    }
    let updateTip = window
      .$("<div class='bsy-update-tip' />")
      .css({ "z-index": window.FX.STATIC.zIndex++ })
      .appendTo(window.$("body"));
    let strKey = "bbynotice_" + noticeinfo.cookie_str;
    window
      .$("<div class='update-title' />")
      .append(window.$("<span />").text(noticeinfo.title))
      .append(
        window.$("<i class='icon icon-bsy-close' />").on("click", function () {
          const closeTime = Math.ceil(new Date().getTime() / 1000);
          const endTime = noticeinfo.endtime - closeTime;
          updateTip.animate({ right: -updateTip.width() + "px" }, 0);
          setTimeout(function () {
            updateTip.remove();
          }, 500);
          endTime > 0 &&
            window.FX.Cookie.set(strKey, closeTime, {
              expires: new Date(noticeinfo.endtime * 1000),
              path: "/",
            });
        })
      )
      .appendTo(updateTip);
    window
      .$("<div class='update-cont' />")
      .append(window.$("<span />").text(noticeinfo.content))
      .appendTo(updateTip);
    window
      .$("<div class='update-btn' />")
      .append(
        window
          .$("<a />")
          .on("click", function () {
            const closeTime = Math.ceil(new Date().getTime() / 1000);
            const endTime = noticeinfo.endtime - closeTime;
            window.FX.Utils.redirectTo(noticeinfo.link, "_blank");
            endTime > 0 &&
              window.FX.Cookie.set(strKey, closeTime, {
                expires: new Date(noticeinfo.endtime * 1000),
                path: "/",
              });
          })
          .text(React.language("view.detail"))
      )
      .appendTo(updateTip);
  };

  openMessage = (event) => {
    const _this = this;
    new window.FX.Slider({
      title: React.language("message.center"),
      contentWidget: {
        type: "messagecenter",
      },
      onClose: function () {
        _this._getMsgUnread(function (e) {
          if (e.count > 0) {
            _this.setState({ haveNews: true });
          } else {
            _this.setState({ haveNews: false });
          }
        });
      },
    }).show();
  };

  _getMsgUnread = (cb) => {
    let b = this;
    window.FX.Utils.ajax(
      {
        url: "/message/unread",
      },
      function (d) {
        b.setState(
          {
            haveNews: d.count > 0,
            noticeinfo: d.noticeinfo,
          },
          () => {
            b.noticeinfo = d.noticeinfo;
            b.createUpDateTip(d);
            cb && cb(d);
          }
        );
      }
    );
  };

  exprotOpen = () => {
    new window.FX.Slider({
      title: React.language("export.management"),
      contentWidget: {
        type: "formexportpane",
      },
      onClose: function () {
        clearTimeout(window.eventid);
      },
    }).show();
  };

  userMananger = () => {
    window.location.href =
      "/corp/addressbook?referer_uri=" + window.location.href;
  };

  showFavorite = async () => {
    try {
      const resdata = await React.axios("/dashboard/app_group/list");
      BsySlidePane({
        title: React.language("app.favorites"),
        hasHeader: true,
        onContentCreate: (ref) => {
          return (
            <BrowserRouter>
              <BsyDashboardComponent
                block={{
                  id: "favorites",
                  name: React.language("app.favorites"),
                }}
                richText={{}}
                apps={resdata.data.items}
                mode={"visit"}
                onRefreshChars={() => { }}
                onUpdataApps={() => {
                  window.hasUpdatefavorites = true;
                }}
              />
            </BrowserRouter>
          );
        },
        onClose: () => {
          if (window.hasUpdatefavorites) {
            window.location.reload();
          }
          return true;
        },
      });
    } catch (res) {
      console.error(res);
    }

    // .then(async (res) => {
    //   this.appMap = null;
    //   let standardAppData = []; //分组会混乱，所以不使用，标准应用在标准应用中请求

    //   let apps = this._getCache(
    //     res.data.dock_items
    //       ? [...res.data.items, ...res.data.dock_items, ...standardAppData]
    //       : [...res.data.items, ...standardAppData]
    //   );
    //   document.querySelector(".bsy-dashboard")?.classList?.add("ready");
    //   if (BsyUtils.isObjectEmpty(this.appMap)) {
    //     this.setState({
    //       appEmpty: true,
    //       success: !0,
    //       apps: [...res.data.items],
    //     });
    //   } else {
    //     this.setState({
    //       appsCache: apps,
    //       success: !0,
    //       dockItem: res.data.dock_items ? [...res.data.dock_items] : [],
    //       dockCorp: res.data.dock_corps ? [...res.data.dock_corps] : [],
    //       apps: [...res.data.items, ...standardAppData],
    //     });
    //   }
    // })
    // .catch((res) => {
    //   console.error(res);
    // });
  };


  openBrowser = () => {
    var url = window.location.href;
    window.FX.Utils.dataAjax(
      {
        url: "/sso/getJumpUrl",
        data: {
          url: url,
        },
      },
      function (data) {
        if (window.wx) {
          window.wx.invoke(
            "openDefaultBrowser",
            {
              url: data.url, // 在默认浏览器打开redirect_uri，并附加code参数；也可以直接指定要打开的url，此时不会附带上code参数。
            },
            function (res) {
              if (res.err_msg != "openDefaultBrowser:ok") {
                //错误处理
              }
            }
          );
        } else {
          window.open(data.url);
        }
      },
      null
    );
  };


  openUserCenterMenu = (event) => {
    const curteam = BsyUtils._getTeamName(window.localDevInfo.corpId);
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: () => {
        return (
          <div className="bby-user-center">
            <div className="user-name">{window.localDevInfo.user.nickname}</div>
            <div className="user-team">
              <span className="team-    " title={curteam}>
                {curteam}
              </span>
              <span className="team-status">
                {window.localDevInfo.user.corpId === window.localDevInfo.corpId
                  ? React.language("team.status.owned")
                  : React.language("team.status.joined")}
              </span>
            </div>
            <div className="split-line" />
            <div className="menu-cont">
              <a
                className="menu-item"
                href={window.rootDirectroy + "/dashboard/user_center"}
              >
                <i className="icon-bsy-iconzhanghao" />
                <span>{React.language("nav.profile")}</span>
              </a>
              <a
                className="menu-item"
                onClick={this.showFavorite}
              // href={window.rootDirectroy + "/dashboard/user_center"}
              >
                <i className="icon-new-shoucangxianxing" />
                <span>{React.language("app.favorites")}</span>
              </a>
              <a
                className="menu-item"
                href={
                  window.rootDirectroy +
                  (window.localDevInfo.user_corps.isCorpOwn
                    ? "/dashboard/profile"
                    : "/dashboard/profile#/loginlog")
                }
              >
                <i className="icon-bsy-iconqiyeshezhi" />

                <span>{React.language("corp.management")}</span>
              </a>
              {window.localDevInfo.user_corps.isCorpOwn &&
                parseInt(
                  window.siteDevInfo.sitesetting.member_purchase_switch
                ) === 1 && (
                  <a
                    className="menu-item"
                    href={window.rootDirectroy + "/dashboard/profile#/member"}
                  >
                    <i className="icon-bsy-icontaocangoumai" />
                    <span>{React.language("membership.purchase")}</span>
                  </a>
                )}
              {/*{*/}
              {/*    window.localDevInfo.user_corps.isCorpOwn && <a className="menu-item" href="/dashboard/bby_modules">*/}
              {/*        <i className="icon-bsy-iconmokuaizhongxin" />*/}
              {/*        <span>{React.language("module")}</span>*/}
              {/*    </a>*/}
              {/*}*/}
              {(window.localDevInfo.user_corps.isSysManager ||
                window.localDevInfo.user_corps.isCorpOwn) && (
                  <a
                    className="menu-item"
                    href={window.rootDirectroy + "/open/api"}
                  >
                    <i className="icon-webhook-open" />
                    <span>{React.language("open.platform")}</span>
                  </a>
                )}
              <a className="menu-item" onClick={this.exprotOpen}>
                <i className="icon-bsy-reportmenu-8" />
                <span>{React.language("export.management")}</span>
              </a>
              {(window.localDevInfo.user_corps.isSysManager ||
                window.localDevInfo.user_corps.isCorpOwn) &&
                (window.localDevInfo?.user_corps?.standard_app_switch ||
                  false) && (
                  <a
                    className="menu-item"
                    href={window.rootDirectroy + "/team/standard"}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <i className="icon-bsy-standard-app" />
                    <span>{React.language("standard.application")}</span>
                  </a>
                )}
              <div className="split-line" />
              {BsyUtils.isDingdingBrowser() ||
                BsyUtils.isWechatWorkBrowser() ? (
                <a
                  className="menu-item"
                  // eslint-disable-next-line no-script-url
                  href="javascript:void(0)"
                  onClick={this.openBrowser}
                >
                  <i className="icon-bsy-open-browser" />
                  <span>{React.language("openBrowser")}</span>
                </a>
              ) : (
                <a
                  className="menu-item"
                  href={window.rootDirectroy + "/user/logout"}
                >
                  <i className="icon-bsy-icontuichuzhanghao" />
                  <span>{React.language("signout")}</span>
                </a>
              )}
            </div>
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      minWidth: 130,
      contentPadding: 0,
      edge: 200,
      dockPosition: "right",
      // "marginTop":20,
      onClose: function () {
        return !1;
      },
    });
  };

  toTarget = (app, n, s) => {
    this.setState(
      {
        seach: false,
      },
      () => {
        if (app.type === "app") {
          let appCache = BsyUtils.getEntryCache(app._id);
          if (BsyUtils.isObjectEmpty(appCache)) {
            this.props.history.push(
              window.rootDirectroy + "/team/app/" + app._id
            );
          } else {
            this.props.history.push(
              `${window.rootDirectroy}/team/app/${appCache.appid}/${appCache.type}/${appCache.entryid}`
            );
          }

          // this.props.history.push(`/team/app/${app._id}`)
        } else {
          this.props.history.push(
            `${window.rootDirectroy}/team/app/${app.appId}/${app.type}/${app.entryId}`
          );
        }
        s && s.closeAlter();
        window.location.reload();
      }
    );
  };

  render() {
    const { haveNews, name, search, showSearch } = this.state;

    return (
      <div className={"bsy-right-menu"}>
        {search === true ? (
          <>
            {!showSearch ? (
              <>
                <div
                  className="item search-result"
                  onClick={() => {
                    this.setState(
                      {
                        showSearch: true,
                      },
                      () => {
                        this.searchResultRef.current?.input?.current?.focus();
                        this.props?.onShowSearch?.(true);
                      }
                    );
                  }}
                >
                  <i className="icon-bsy-reportmenu-0" />
                </div>
              </>
            ) : (
              <>
                <BsySearchResult
                  dockPosition="center"
                  autoClose={false}
                  isStandard={this.props.isStandard}
                  ref={this.searchResultRef}
                  async={{
                    url: "/dashboard/search",
                    data: {
                      type: "all",
                      mode: "all",
                      range: this.props.isStandard ? "standard" : "noStandard",
                    },
                    sucess: (items) => {
                      return items.list;
                    },
                  }}
                  // inputValue={searchValue}
                  minHeight={40}
                  maxHeight={350}
                  width={240}
                  onBlur={(e) => {
                    this.setState(
                      {
                        showSearch: false,
                      },
                      () => {
                        this.props?.onShowSearch?.(false);
                      }
                    );
                    return false;
                  }}
                  placeholder={React.language("searchAppForm")}
                  onCreatResult={(res, s) => {
                    let appItem = [];
                    let otherItem = [];
                    if (res && res.length > 0) {
                      res.map((val) => {
                        if (val.type !== "app") {
                          otherItem.push(val);
                        } else {
                          appItem.push(val);
                        }
                        return null;
                      });
                    }
                    return res && res.length > 0 ? (
                      <div className="searchAllAppFormReport">
                        <ul className="searchFormDashReport">
                          {otherItem.length > 0 ? (
                            otherItem.map((val) => {
                              return (
                                val && (
                                  <li
                                    key={val.id}
                                    onClick={(e) => {
                                      this.toTarget(val, null, s);
                                    }}
                                  >
                                    <div className="contView">
                                      <div
                                        className="menu-item"
                                        title={val.text}
                                      >
                                        <i
                                          className={`node-icon icon-bsy-${val.type
                                            }${!val.hasCoop ? "-flow" : ""} ${val.icon > 24
                                              ? "icon-new-bsy-form-" + val.icon
                                              : `icon-bsy-form-${val.icon}`
                                            }`}
                                        />
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: val.titleHtml,
                                          }}
                                        />
                                      </div>
                                      <div className="appNameItem">
                                        <span>{val.appName}</span>
                                      </div>
                                      {val.mode === "dock" && (
                                        <div
                                          className="dockItem"
                                          title={
                                            React.language(
                                              "organization.external"
                                            ) +
                                            ":" +
                                            val.corp_name
                                          }
                                        >
                                          {React.language(
                                            "organization.external"
                                          ) +
                                            ":" +
                                            val.corp_name}
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                )
                              );
                            })
                          ) : (
                            <li className="emptySearchForm">
                              {React.language("dash.form.empty")}
                            </li>
                          )}
                        </ul>
                        <ul className="searchApp dock">
                          {appItem.length > 0 ? (
                            appItem.map((val) => {
                              return (
                                val && (
                                  <li
                                    key={val.id}
                                    onClick={(e) => {
                                      this.toTarget(val, "isApp", s);
                                    }}
                                  >
                                    <div className="appItem">
                                      <div
                                        className={
                                          "app-icon color-cover-" +
                                          val.style.color
                                        }
                                      >
                                        <div
                                          className={
                                            "imgbg-small-bsy-app imgbg-bsy-app-" +
                                            val.style.icon
                                          }
                                        />
                                      </div>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: val.titleHtml,
                                        }}
                                      />
                                    </div>
                                    {val.mode === "dock" && (
                                      <div
                                        className="dockItem"
                                        title={
                                          React.language(
                                            "organization.external"
                                          ) +
                                          ":" +
                                          val.corp_name
                                        }
                                      >
                                        {React.language(
                                          "organization.external"
                                        ) +
                                          ":" +
                                          val.corp_name}
                                      </div>
                                    )}
                                  </li>
                                )
                              );
                            })
                          ) : (
                            <li className="emptySearchForm">
                              {React.language("app.all.empty")}
                            </li>
                          )}
                        </ul>
                      </div>
                    ) : (
                      <div className="emptySearchAll">
                        {React.language("field.location.empty")}
                      </div>
                    );
                  }}
                />
              </>
            )}
            <div className="split-line"></div>
          </>
        ) : (
          ""
        )}

        {BsyUtils.isMemberManage() ? (
          <>
            <div
              className="item user-manager"
              data-for="user-manager"
              data-tip={React.language("contacts")}
              onClick={this.userMananger}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("contacts"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
            >
              <i className="icon-bsy-user-manager" />
            </div>
          </>
        ) : (
          ""
        )}

        {window.siteDevInfo.sitesetting?.help_menu_switch === 1 && (
          <>
            <div
              className="item system-help"
              data-for="system-help"
              data-tip={React.language("help")}
              onClick={BsyUtils.openHelpMenu}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("help"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={this.hideTooltip}
            >
              <i className="icon-bsy-system-help" />
            </div>
          </>
        )}
        <div
          className="item system-msg"
          data-for="system-msg"
          data-tip={React.language("message.center")}
          onClick={this.openMessage}
          onMouseEnter={(e) => {
            this.showTooltip(
              e.currentTarget,
              React.language("message.center"),
              "bottom",
              10
            );
          }}
          onMouseLeave={this.hideTooltip}
        >
          <i className="icon-bsy-msg" />
          {haveNews && <span className="have" />}
        </div>
        <div className="split-line"></div>
        <div className="item user-portrait" onClick={this.openUserCenterMenu}>
          {window.localDevInfo.user.avatarurl ? (
            <img src={window.localDevInfo.user.avatarurl} alt="" />
          ) : (
            <div className={"user-portrait-name color-" + name.color}>
              {name.name}
            </div>
          )}
          <div className="box-shaw">
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }
}

BsySystemRightMenu.propTypes = {};

export default withRouter(BsySystemRightMenu);
